import CustomerProjectFlowConnect from '../../../CustomerProjectFlow/CustomerProjectFlowProps'

interface CustomerOpportunitiesStatusFlowProps { }

const CustomerOpportunitiesStatusFlow: React.FC<CustomerOpportunitiesStatusFlowProps> = () => {
    return (<CustomerProjectFlowConnect projectTypeStatus={0} />)
}

export default CustomerOpportunitiesStatusFlow